import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-[#0a2a5e] via-[#0f3d8c] to-[#0a3570] text-white pt-12 sm:pt-16 pb-6 sm:pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12 mb-8 sm:mb-12">
          <div>
            <img
              alt="CX Comercializadora"
              className="h-14 sm:h-16 mb-4 brightness-0 invert"
              src="https://static.readdy.ai/image/44126011924ab97e0c4eb5476e9c701c/03ddab0fb09532e94d7645cd24b4fbb6.png"
            />
            <p className="text-white/80 text-sm leading-relaxed">
              Tu aliado estratégico en suministros de oficina en Puebla. Calidad, rapidez y atención personalizada.
            </p>
          </div>
          
          <div>
            <h4 className="font-bold text-lg mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/soluciones-empresas" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Soluciones Empresas
                </Link>
              </li>
              <li>
                <Link to="/catalogo" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Catálogo
                </Link>
              </li>
              <li>
                <Link to="/como-trabajamos" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Cómo Trabajamos
                </Link>
              </li>
              <li>
                <Link to="/nosotros" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Nosotros
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold text-lg mb-4">Recursos</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/blog" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold text-lg mb-4">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-xl flex-shrink-0 mt-0.5"></i>
                <span className="text-white/80">2228121142</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-xl flex-shrink-0 mt-0.5"></i>
                <span className="text-white/80 break-words">cxventas.com.pue@gmail.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-xl flex-shrink-0 mt-0.5"></i>
                <span className="text-white/80">Puebla, México</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line text-xl flex-shrink-0 mt-0.5"></i>
                <span className="text-white/80">Lunes a Viernes: 8:00 AM - 6:00 PM</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-white/20 pt-6 sm:pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-center md:text-left">
          <p className="text-white/70 text-xs sm:text-sm leading-relaxed">
            © 2024 CX Comercializadora de Puebla. Todos los derechos reservados. |{' '}
            <Link className="hover:text-white transition-colors cursor-pointer" to="/aviso-privacidad">
              Aviso de Privacidad
            </Link>{' '}
            |{' '}
            <a
              href="https://axoria.mx"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors cursor-pointer"
            >
              Desarrollado por axoria.mx
            </a>
          </p>
          <div className="flex gap-4">
            <a
              href="https://www.facebook.com/CXComercializadoraPuebla?locale=es_LA"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
            >
              <i className="ri-facebook-fill text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;